import React, { useEffect, useState } from "react";
import { Button, CmsContent, Container, Icon, Image } from "components";
import { BackgroundColourEnum, ContainerSpacingEnum, ContainerWidthEnum } from "utils";
import { TeamProfilesQueryFragment } from "codegen";
import "./TeamProfiles.scss";
import AOS from "aos";
import "aos/dist/aos.css";
import Modal from "react-modal";

/* Appended the modal.
 * The app element should not be a parent of the modal,
 * to prevent modal content from being hidden to screenreaders while it is open. */
Modal.setAppElement("#___gatsby");
Modal.defaultStyles.overlay.zIndex = "99";

// Modal.setAppElement("#site-container");

interface TeamProfilesProps {
  data: TeamProfilesQueryFragment;
}

export const TeamProfiles = ({ data }: TeamProfilesProps): JSX.Element => {
  useEffect(() => {
    AOS.init();
  }, []);
  const {
    heading = "",
    content = "",
    profiles = [],
    backgroundColour,
    containerWidth,
    containerSpacing,
    sectionId,
  } = data;
  if (profiles.length > 0) {
    return (
      <Container
        className="team-profiles"
        backgroundColour={BackgroundColourEnum[backgroundColour]}
        containerWidth={ContainerWidthEnum[containerWidth]}
        containerSpacing={ContainerSpacingEnum[containerSpacing]}
        sectionId={sectionId}
      >
        <div className="team-profiles__intro" data-aos="fade-up">
          {heading.length > 0 && <h2>{heading}</h2>}
          {content.length > 0 && <CmsContent content={content} />}
        </div>
        <div className="team-profiles__grid">
          {Object.keys(profiles).length > 0 &&
            profiles?.map((profile, index) => {
              return <ProfileItem {...profile} key={`team-${index}`} />;
            })}
        </div>
      </Container>
    );
  }

  return null;
};

const ProfileItem = ({ image, name, position, introBio, bio }) => {
  const [modalIsOpen, setIsOpen] = useState<boolean>(false);

  function closeModal() {
    setIsOpen(false);
  }
  useEffect(() => {
    AOS.init();
  }, []);
  return (
    <div className="team-profiles__profile" data-aos="fade-up">
      <div className="team-profiles__profile__image">{image && <Image src={image} alt={name} />}</div>
      <h3 className="typography--h3 team-profiles__profile__name">{name}</h3>
      <p className="team-profiles__profile__position">{position}</p>
      {introBio.length && <CmsContent content={introBio} />}
      {bio && (
        <Button variant="outline" colorScheme="secondary" rightIcon="ArrowLink" onClick={() => setIsOpen(true)}>
          Read bio
        </Button>
      )}

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={() => setIsOpen(false)}
        className="modal__wrapper"
        overlayClassName="modal__overlay"
      >
        <button onClick={closeModal} className="modal__close">
          <Icon name="Close" size={2} />
        </button>
        <div className="modal__content">
          <span className="team-profiles__profile__decorative-name">{name}</span>
          {image && <Image src={image} alt={name} />}
          <div>
            <p className="typography--h3 team-profiles__profile__name">{name}</p>
            <p className="team-profiles__profile__position">{position}</p>
            {bio.length && <CmsContent content={bio} />}
          </div>
        </div>
      </Modal>
    </div>
  );
};
